import React from 'react';
import { Route } from 'react-router';

import Page from './component';

export default <Route
    exact
    key="accounting-documents"
    path="/accounting-documents"
    component={Page} />;